// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-container[data-v-22eb8d25]{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6;padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert-container a.link[data-v-22eb8d25]{color:inherit;text-decoration:none}", ""]);
// Exports
module.exports = exports;
